export const environment = {
    // Staging API runs on the small-projects VPS, separate DB + secrets
    // from prod. See caro-logboek-backend/docs/runbooks/staging-deployment.md
    // for the backend side of this hostname.
    apiUrl: 'https://test-api.showlogger.com/api/v1',
    fileUrl: 'https://test-api.showlogger.com/api/v1/files',
    appEnvironment: 'test',
    appVersion: '2.24.5',
    production: true,
    appName: 'Showlogger TEST',
    // Distinct App Store / Play Store record so TestFlight + Play Internal
    // can install side-by-side with the production app without conflicting
    // on bundle id. The Fastfile :beta_test lane also writes these into the
    // Xcode project + AndroidManifest before building.
    iosAppBundleId: 'nl.royschrauwen.showlogger.test',
    androidAppBundleId: 'nl.royschrauwen.showlogger.test',
    build: '1784185745',
    enableSentry: true,
    sentryDsn: 'https://ed5565928717fddb870ae24af88b10d9@o4505273847054336.ingest.sentry.io/4505976057364480'
};
